import { Component, Vue } from "vue-property-decorator";
import DxDropDownBox from 'devextreme-vue/drop-down-box';
import DxTreeView from 'devextreme-vue/tree-view';
import { DxCheckBox } from 'devextreme-vue/check-box';
import DxTextBox from 'devextreme-vue/text-box';
import DxTextArea from 'devextreme-vue/text-area';
import templatesModule from '@/store/modules/templates.module';
import offerDemandModule from '@/store/modules/offer-demand.module';
import { ItiVHeader } from "@/iti-core-vuetify";

@Component({
  components: {
    DxDropDownBox,
    DxTreeView,
    DxCheckBox,
    DxTextBox,
    DxTextArea,
  }
})
export default class AdvancedSearch extends Vue {
  public loading = false;
  public searched = '';
  public isSearchable: boolean = false;
  public offer: boolean = false;
  public demand: boolean = false;
  public postalCode: string = "";
  public description: string = "";
  public category: string = '';
  public code: string = '';
  public level: number = 0;
  public treeViewName = 'tree-view';

  public get categories() {
    return templatesModule.formattedCategoriesList;
  }

  public get searchResult() {
    return offerDemandModule.searchResults;
  }

  public get headers() {
    return [        
        new ItiVHeader('name', this.$tc('offers-demands.name')),
        new ItiVHeader('description', this.$tc('offers-demands.description')),
        new ItiVHeader('categoryFirstLevelCode', this.$tc('offers-demands.category1')),
        new ItiVHeader('categorySecondLevelCode', this.$tc('offers-demands.category2')),
        new ItiVHeader('categoryThirdLevelCode', this.$tc('offers-demands.category3')),
        new ItiVHeader('categoryFourthLevelCode', this.$tc('offers-demands.category4')),
        new ItiVHeader('offer', this.$tc('offers-demands.offer') + " o " + this.$tc('offers-demands.demand')),
        // new ItiVHeader('location', this.$tc('offers-demands.location')),
        new ItiVHeader('postalCode', this.$tc('offers-demands.postalCode')),
        new ItiVHeader('photoURL', this.$tc('offers-demands.photo')),
    ];
  }

  public mounted() {
    templatesModule.getFormattedCategories();
  }

  public onSelectedCategory(event: any) {
    this.category = event.itemData.description;
    this.code = event.itemData.code;
    this.level = event.itemData.level;
  }

  public search() {
    var search = new AdvancedSearch();
    search.code = this.code;
    search.level = this.level;
    if(this.category == undefined)
      search.level = 0;
    search.offer = this.offer;
    search.demand = this.demand;
    search.postalCode = this.postalCode;
    search.description = this.description;

    offerDemandModule.getAdvancedSearch(search);
  }

  public offerDemanOnClick() {
    this.isSearchable = false;
    if(this.offer) this.isSearchable = true;
    if(this.demand) this.isSearchable = true;
  }
}
